const customFieldMappings = [
  {
    type: "Customer Type",
    name: "CUSTOMER_PAYMENTACCOUNTIDS_FIELD",
    typeKey: "Customer",
    key: "customer-type",
    tenantField: "customer_paymentaccountids_field",
    required: false,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_FULFILLMENT_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_fulfillment_field",
    staticOptions: [
      { label: "takeWith", value: "takeWith" },
    ],
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_ISGIFT_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_isgift_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_MISTID_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_mistid_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_PRICEOVERRIDEAPPROVER_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_priceoverrideapprover_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_PRICEOVERRIDECODE_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_priceoverridecode_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_PRICEOVERRIDETYPE_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_priceoverridetype_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_PRICEOVERRIDEVALUE_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_priceoverridevalue_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_PURCHASELINEITEMID_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_purchaselineitemid_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_PURCHASEORDERID_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_purchaseorderid_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_RETURNCOMMENT_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_returncomment_field",
    required: true,
  },
  {
    type: "In-Store Line Item Type",
    name: "LINEITEM_SALESPERSONID_FIELD",
    typeKey: "Lineitem",
    key: "in-store-lineitem-type",
    tenantField: "lineitem_salespersonid_field",
    required: true,
  },
  {
    type: "In-Store Order Type",
    name: "ORDER_LOCATIONID_FIELD",
    typeKey: "Cart/Order",
    key: "in-store-order-type",
    tenantField: "order_locationid_field",
    required: true,
  },
  {
    type: "In-Store Order Type",
    name: "ORDER_ORDERTYPE_FIELD",
    typeKey: "Cart/Order",
    key: "in-store-order-type",
    tenantField: "order_ordertype_field",
    required: true,
  },
  {
    type: "In-Store Order Type",
    name: "ORDER_SEQUENCE_NUMBER_FIELD",
    typeKey: "Cart/Order",
    key: "in-store-order-type",
    tenantField: "order_sequence_number_field",
    required: true,
  },
  {
    type: "In-Store Order Type",
    name: "ORDER_USERID_FIELD",
    typeKey: "Cart/Order",
    key: "in-store-order-type",
    tenantField: "order_userid_field",
    required: true,
  },
  {
    type: "In-Store Order Type",
    name: "ORDER_WORKSTATIONID_FIELD",
    typeKey: "Cart/Order",
    key: "in-store-order-type",
    tenantField: "order_workstationid_field",
    required: true,
  },
  {
    type: "In-Store Payment Type",
    name: "PAYMENT_ACCOUNTNAME_FIELD",
    typeKey: "Payment",
    key: "in-store-payment-type",
    tenantField: "payment_accountname_field",
    required: false,
  },
  {
    type: "In-Store Payment Type",
    name: "PAYMENT_ACCOUNTNUMBER_FIELD",
    typeKey: "Payment",
    key: "in-store-payment-type",
    tenantField: "payment_accountnumber_field",
    required: false,
  },
  {
    type: "In-Store Payment Type",
    name: "PAYMENT_BARCODE_FIELD",
    typeKey: "Payment",
    key: "in-store-payment-type",
    tenantField: "payment_barcode_field",
    required: false,
  },
  {
    type: "In-Store Payment Type",
    name: "PAYMENT_CUSTOMERNUMBER_FIELD",
    typeKey: "Payment",
    key: "in-store-payment-type",
    tenantField: "payment_customernumber_field",
    required: false,
  },
  {
    type: "In-Store Payment Type",
    name: "PAYMENT_ISSUERID_FIELD",
    typeKey: "Payment",
    key: "in-store-payment-type",
    tenantField: "payment_issuerid_field",
    required: false,
  },
  {
    type: "In-Store Payment Type",
    name: "PAYMENT_MISTID_FIELD",
    typeKey: "Payment",
    key: "in-store-payment-type",
    tenantField: "payment_mistid_field",
    required: false,
  },
  {
    type: "MIST Transaction Type",
    name: "ORDER_EMAILTRIGGERED_FIELD",
    typeKey: "Transaction",
    key: "mist-transaction-type",
    tenantField: "order_emailtriggered_field",
    required: false,
  },
  {
    type: "In-Store Payment Type",
    name: "PAYMENT_PROCESSOR_FIELD",
    typeKey: "Payment",
    key: "in-store-payment-type",
    tenantField: "payment_processor_field",
    required: false,
  },
  {
    type: "In-Store Payment Type",
    name: "PAYMENT_EXTERNALID_FIELD",
    typeKey: "Payment",
    key: "in-store-payment-type",
    tenantField: "payment_externalId_field",
    required: false,
  },
  {
    type: "MIST Transaction Type",
    name: "PAYMENT_CASHROUNDING_FIELD",
    typeKey: "Transaction",
    key: "mist-transaction-type",
    tenantField: "payment_cashrounding_field",
    required: false,
  }
];


export default customFieldMappings;
